import { Form } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect } from '../../../../StyledComponents';

export const OtherInformationFormalSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formBecomingAwareThrough">
                <Form.Label>Wie sind Sie auf uns aufmerksam geworden?</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="becomingAwareThrough"
                    value={values.becomingAwareThrough}
                    isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                    isInvalid={errors.becomingAwareThrough}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.becomingAwareThrough}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};